/**
 * @file SolicitarValidacao/index.js
 * @author Diego Sabino Amorim de Araújo
 * @description Componente de solicitação de e-mail para preenchimentos dos dados pendentes do usuário
 *
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Link,
  Grid,
  TextField,
  Button,
} from '@material-ui/core'
import { useAuth } from 'hooks/useAuth'
import { useSessionService } from 'hooks/useSessionService'
import useRouter from 'utils/useRouter'
import { Page } from 'components'
import { Logo } from 'components/Logo'

import useStyles from './styles'

export const SolicitarValidacao = () => {
  const classes = useStyles()
  const router = useRouter()
  const { currentUser } = useAuth()
  const sessionService = useSessionService()

  const handleEnviarEmail = async () => {
    await sessionService.solicitarEmailUsuarioPendente(currentUser.id)
    router.history.push('/auth/login')
  }

  return (
    <Page className={classes.root} title="Dados pendentes - SIGEP">
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <div className={classes.profile}>
            <Logo />
            <Typography gutterBottom variant="h4">
              Enviar e-mail para preenchimentos dos dados pendentes
            </Typography>
          </div>

          <Grid container className={classes.loginForm}>
            <Grid item sm={12} xs={12} md={12} className={classes.item}>
              <TextField
                fullWidth
                disabled
                label="E-mail"
                name="email"
                value={
                  currentUser && currentUser.email ? currentUser.email : 'e-mail não cadastrado'
                }
                variant="outlined"
                required
              />
            </Grid>
            <Grid item sm={12} xs={12} md={12}>
              <Button
                fullWidth
                className={classes.submitButton}
                color="secondary"
                size="large"
                type="submit"
                variant="contained"
                disabled={!currentUser || !currentUser.email}
                onClick={handleEnviarEmail}
              >
                Enviar e-mail
              </Button>
            </Grid>
          </Grid>

          <Divider className={classes.divider} />
          <Link
            align="center"
            color="secondary"
            component={RouterLink}
            to="/auth/login"
            underline="always"
            variant="subtitle2"
          >
            Voltar a tela de login
          </Link>
        </CardContent>
      </Card>
    </Page>
  )
}
